// শুধু এই ইমেইল দিয়ে লগইন করলেই sensitive action (যেমন delivery charge payer বদলানো) করা যাবে।
export const ADMIN_EMAIL = 'admin@kizunainventory.com';

export const isAdminUser = (user) => user?.email === ADMIN_EMAIL;
